import constants from './constants';

const {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
} = constants;

const getActionsByStatus = (status) => {
  const {
    transfer,
    finish,
    remove,
    resume,
  } = TOURNAMENT_MEMBER_ACTIONS;
  switch (status) {
    case TOURNAMENT_MEMBER_STATUS.waited: return [transfer, finish, remove];
    case TOURNAMENT_MEMBER_STATUS.ended: return [resume];
    default:
    case TOURNAMENT_MEMBER_STATUS.transfered: return [];
  }
};

export default {
  getActionsByStatus,
};
